/** Grymwyrd 日本語版 Play / VTT フィーチャーのコピー */
export const playJa = {
  // CampaignList
  'play.campaigns.heading': '私のキャンペーン',
  'play.campaigns.signIn': 'サインイン',
  'play.campaigns.signInToSee': 'してご参加中のキャンペーンをご覧ください。',
  'play.campaigns.fallbackNotice': 'サンプルキャンペーンを表示しています。あなたの一覧が読み込めませんでした。',
  'play.campaigns.loading': 'サーガを呼び起こしています…',
  'play.campaigns.empty': 'まだどのキャンペーンにも参加していません。',
  'play.campaigns.assignedCharacter': 'アサイン済みキャラクター',
  'play.campaigns.unassigned': 'アサイン未',
  'play.campaigns.noCharactersYet': 'キャラクターはまだいません',
  'play.campaigns.enterCampaign': 'キャンペーンに入る',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'テーブル',
  'play.vtt.launch': 'VTT を起動',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — キャンペーン {campaignId}',
  'play.vtt.veilHeadline': 'テーブルと物語の間のヴェイルは薄い。',
  'play.vtt.prototypeIntro':
    'リアルタイム仮想テーブルトップは後の段階です。インタラクティブなプロトタイプはこのフレームに埋め込まれます。',
  'play.vtt.prototypeOutro': 'を押してコンテナを準備します。',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'コーデックス クイックサーチ',
  'play.codex.searchPlaceholder': 'モンスター、スペル、ルールを検索…',
  'play.codex.searchAriaLabel': '百科事典を検索',
  'play.codex.searching': 'スクライング中…',
  'play.codex.noResults': '「{q}」に該当する項目はありません。',
  'play.codex.hint': 'テーブルから離れずに百科事典を検索するには、最低 2 文字入力してください。',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'キャンペーン',
  'play.campaign.fallbackDescription':
    'キャンペーン詳細が読み込めませんでしたが、以下でキャラクターを準備できます。',
  'play.campaign.seoTitle': 'キャンペーン',
  'play.campaign.noneSpecified': 'キャンペーンが指定されていません。',
  'play.campaign.seoTitleNamed': '{title} — プレイ',
  'play.campaign.seoTitleDefault': 'キャンペーン — プレイ',
  'play.campaign.backToLobby': 'ロビーに戻る',
  'play.campaign.gm': 'ゲームマスター {gm}',
  'play.campaign.playersCount': '{count} 人のプレイヤー',

  // CharacterSheet
  'play.sheet.savedToCodex': 'コーデックスに保存しました。',
  'play.sheet.savedLocally': 'ローカルに保存しました（サーバーが利用不可）。',
  'play.sheet.saveError': 'キャラクターを保存できません。ストレージが利用できません。',
  'play.sheet.loading': 'シートを広げています…',
  'play.sheet.heading': 'キャラクター シート',
  'play.sheet.avatarAlt': '{name} のアバター',
  'play.sheet.unclaimedHero': 'クレーム未のヒーロー',
  'play.sheet.abilityCheck': '{ability} チェック（{formula}）：',
  'play.sheet.name': 'キャラクター名',
  'play.sheet.namePlaceholder': '名もなき放浪者',
  'play.sheet.level': 'レベル',
  'play.sheet.speciesLabel': '血統 / 種族',
  'play.sheet.loadingOption': '読み込み中…',
  'play.sheet.selectSpecies': '種族を選択',
  'play.sheet.classLabel': 'クラス',
  'play.sheet.selectClass': 'クラスを選択',
  'play.sheet.abilityScores': '能力値',
  'play.sheet.abilityScoresHint': '（修正値をクリックしてロール）',
  'play.sheet.abilityScoreAria': '{ability} 能力値',
  'play.sheet.rollCheckAria': '{ability} チェックをロール',
  'play.sheet.hp': 'HP',
  'play.sheet.maxHp': '最大 HP',
  'play.sheet.ac': 'AC',
  'play.sheet.backstory': 'バックストーリー',
  'play.sheet.backstoryPlaceholder': 'この魂をテーブルに連れてきた暗黒とは？',
  'play.sheet.canonCandidate': '正史候補',
  'play.sheet.canonCandidateHint': 'このキャラクターを Grymwyrd 正史の検討対象に登録します。',
  'play.sheet.saving': '保存中…',
  'play.sheet.saveCharacter': 'キャラクターを保存',

  // CreateGameModal
  'play.create.errorNoName': 'テーブルに名前を付けてください。',
  'play.create.errorNoSystem': 'ゲームシステムを選択してください。',
  'play.create.you': 'あなた',
  'play.create.errorCreate': '儀式が失敗しました。テーブルを作成できませんでした。',
  'play.create.modalTitle': 'テーブルを招集',
  'play.create.successCopy': 'テーブルの準備ができました。この招待リンクを共有してプレイヤーを召喚してください。',
  'play.create.copyInviteAria': '招待リンクをコピー',
  'play.create.copied': 'コピーしました',
  'play.create.copy': 'コピー',
  'play.create.done': '完了',
  'play.create.tableName': 'テーブル名',
  'play.create.tableNamePlaceholder': '例：喪の冠婚葬祭所',
  'play.create.quickStart': 'クイックスタート',
  'play.create.quickStartAria': 'クイックスタート プリセット',
  'play.create.customPreset': 'カスタム',
  'play.create.customPresetDesc': 'ゼロから開始',
  'play.create.gameSystem': 'ゲームシステム',
  'play.create.loadingSystems': 'システムを読み込み中…',
  'play.create.systemFromPreset': '{system}（プリセットから）',
  'play.create.systemDefault': 'Grymwyrd Cataclysm（デフォルト）',
  'play.create.tags': 'タグ',
  'play.create.tagsUpTo': '（最大 {count} 個）',
  'play.create.removeTagAria': 'タグを削除 {tag}',
  'play.create.tagLimitReached': 'タグ数の上限に達しました',
  'play.create.tagPlaceholder': 'ホラー、ワンショット…',
  'play.create.maxPlayers': '最大プレイヤー数：',
  'play.create.cancel': 'キャンセル',
  'play.create.convening': '招集中…',
  'play.create.createTable': 'テーブルを作成',

  // JoinPage
  'play.join.finding': 'テーブルを探しています…',
  'play.join.expiredHeading': 'この招待は期限切れです',
  'play.join.expiredBody': 'コードはセキュリティのため有効期限があります。ホストに新しいコードをリクエストしてください。',
  'play.join.browseLiveTables': 'ライブテーブルを参照',
  'play.join.errorHeading': 'テーブルに接続できませんでした',
  'play.join.errorBody': '招待コードの検索中にエラーが発生しました。接続を確認してもう一度お試しください。',
  'play.join.tryAgain': 'もう一度試す',
  'play.join.defaultTableTitle': 'Grymwyrd テーブル',
  'play.join.invited': '席への招待をお受けしました。',
  'play.join.signInToSeat': 'サインインして席に着く',
  'play.join.createAccount': 'はじめての方は、無料アカウントを作成',
  'play.join.opensAfterSignIn': 'サインイン後、テーブルが開きます。',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'プレイ — 仮想テーブルトップ',
  'play.lobby.seoDescription':
    'テーブルを見つけ、ライブセッションに参加し、Grymwyrd 仮想テーブルトップで伝説を作ります。',
  'play.lobby.eyebrow': '仮想テーブルトップ',
  'play.lobby.title': 'プレイ',
  'play.lobby.subtitle':
    'あなたの魔女団を集めよう。骨を振ろう。Grymwyrd の生きた正史を通じてすべての選択が響く、テーブルに着いてください。',
  'play.lobby.createGame': 'ゲームを作成',
  'play.lobby.playNow': 'プレイ開始 — アカウント不要',
  'play.lobby.signInToHost': 'サインインしてあなた自身のテーブルをホスト',

  // SessionListLive
  'play.live.heading': 'ライブ中',
  'play.live.empty': 'この時間帯にライブのテーブルがありません。ヴェイルは静まり返っています。あなた自身のテーブルを立ち上げてください。',
  'play.live.badge': 'ライブ',
  'play.live.unknownSystem': 'システム不明',
  'play.live.gmSuffix': ' · ゲームマスター {gm}',
  'play.live.players': 'プレイヤー',

  // TableList — empty board
  'play.tables.emptyHeading': 'まだテーブルが開いていません',
  'play.tables.emptyBody':
    'ボードは今のところ静かです。最初に椅子を引き出してください。アカウント不要のゲストテーブルをお試しください。',
  'play.tables.tryGuestTable': 'ゲストテーブルを試す',
  'play.tables.orUse': 'または',
  'play.tables.createGame': 'ゲームを作成',
  'play.tables.aboveToHost': 'を使用して独自のテーブルをホストしてください。',

  // TableList — waitlist
  'play.waitlist.joinError': 'ウェイトリストに参加できません。もう一度試してください。',
  'play.waitlist.leaveError': 'ウェイトリストから削除できません。もう一度試してください。',
  'play.waitlist.join': 'ウェイトリストに参加',
  'play.waitlist.leaving': '削除中…',
  'play.waitlist.leave': 'ウェイトリストから削除',
  'play.waitlist.joining': '参加中…',

  // TableList — board
  'play.tables.heading': 'オープンテーブル',
  'play.tables.openSeatOnly': 'オープンシートのみ',
  'play.tables.systemFilterPlaceholder': 'システム…',
  'play.tables.systemFilterAria': 'システムでフィルター',
  'play.tables.tagsFilterPlaceholder': 'タグ（カンマ区切り）…',
  'play.tables.tagsFilterAria': 'タグでフィルター',
  'play.tables.fetchError': 'ライブボードに接続できません。ロビーは一時的に利用できません。',
  'play.tables.loading': 'テーブルを集めています…',
  'play.tables.untitledTable': 'タイトルなしのテーブル',
  'play.tables.full': '満席',
  'play.tables.seatedCount': '{count} 人が着席',
  'play.tables.viewTable': 'テーブルを表示',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': 'テーブル チャット',
  'chat.empty': 'メッセージはまだありません。テーブルに何か言ってください。',
  'chat.inputPlaceholder': 'テーブルにメッセージを送信…',
  'chat.inputAria': 'チャット メッセージ',
  'chat.send': '送信',
  'chat.translatedFrom': '{lang} から翻訳',
  'chat.original': 'オリジナル',
  'chat.showOriginal': 'オリジナルを表示',
  'chat.showTranslation': '翻訳を表示',
  'chat.showOriginalsAll': 'オリジナルをすべて表示',
  'chat.showTranslationsAll': '翻訳をすべて表示',
};
